import axios from 'axios'
import './common'

export default {
    login(params) {
        return axios.post(`/users/signin`, params)
    },
    logout: () => axios.delete('users/signout'),
    skipTuto: () => axios.patch('users/skip-tuto'),
    activate: (token, data) => axios.post(`users/activate/${token}`, data),
    stillConnected: () => axios.get('users/still-connected'),
    hideCircleInfo: () => axios.patch('users/hide-circle-info'),
}